import './styles.scss'
import facebookIcon from '../images/facebook.png'
import twitterIcon from '../images/twitter.png'
import emailIcon from '../images/email.png'
import innerText from 'react-innertext'
const shareImage = `${process.env.PUBLIC_URL}/share.png`
export default function Share(props) {
  const { grove } = props


  let shareTextElement = 'Explore our dedicated groves. A tribute that lasts as long as the redwoods. By Save the Redwoods League.'
  if (grove) {
     shareTextElement = <>Save the Redwoods League Dedicated Groves.<br /> {grove.name} was dedicated in {grove.yearDedicated}.</>
  }
  const shareText = innerText(shareTextElement)
  const shareTypes = [
    {
      icon: facebookIcon,
      type: 'facebook',
      handler: () => {
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(window.location.href), '_blank')
      }
    },
    {
      icon: twitterIcon,
      type: 'twitter',
      handler: () => {
        window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent(shareText) + '&url=' + encodeURIComponent(window.location.href), '_blank')
      }
    },
    {
      icon: emailIcon,
      type: 'email',
      handler: () => {
        window.open('mailto:?subject=Save the Redwoods&body=' + encodeURIComponent(shareText) + ' ' + encodeURIComponent(window.location.href), '_blank')
      }
    }
  ]

  return (
    <div className='Share'>
      <div className='Share-container'>
        <div className='shareUrl'>{window.location.href}</div>
        <div className='shareText' >{shareTextElement}</div>
        <img className='shareImage' src={shareImage} alt={shareText} />
      </div>
      <div className='shareTypes'>
        Share this to: {shareTypes.map((type, i) => (
          <img key={i} src={type.icon} alt={`share to ${type}`} onClick={type.handler} />
        ))}
      </div>
    </div>
  )
}
